import { render, staticRenderFns } from "./MoveObject.vue?vue&type=template&id=56f7a10d&"
import script from "./MoveObject.vue?vue&type=script&lang=js&"
export * from "./MoveObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports